import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import ShopDisplayEdit from '@/views/components/shopDisplaySketchMap/displayEdit';
import ShopDisplay from '@/views/components/shopDisplaySketchMap/display';
import { IPSService } from '@/services/ipsServices';
import { noop, numberToArray } from '@/util';

@Component({
  components: { ShopDisplay, ShopDisplayEdit },
})
export default class ProductInfo extends Vue {
  @Prop({ default: () => {} })
    value: ItemObject;

  @Prop({ default: 1 })
    themeCode: number;

  $refs: {
    config: ElForm;
  };

  // 商详配置详情  封装后
  data: ItemArray = [];

  // 商详配置详情  接口返回
  baseInfo: ItemObject = {};

  // 选中元素下标
  activedIndex = -1;

  ygswpId;

  @Watch('data', { deep: true })
  watchData() {
    this.activedIndex = this.data.findIndex(v => v.isActived);
  }

  created() {
    this.getSgData(Number.parseInt(this.$route.params.id));
    this.getSiteData(+this.$route.params.siteId);
  }

  getSiteData(siteId) {
    siteId
      && IPSService.siteProductInfoConfig({
        postParams: {
          siteId,
        },
      }).then((response) => {
        this.ygswpId = response.ygswpId;
        this.computedData(response);
      });
  }

  getSgData(sgId) {
    sgId
      && IPSService.productInfoConfig({
        postParams: {
          sgId,
        },
      }).then((response) => {
        this.computedData(response);
      });
  }

  computedData(response) {
    this.baseInfo = response;
    let temp: ItemArray = [
      {
        fieldType: 'ProductInfo',
        isActived: false,
        baseSort: 1,
      },
    ];
    temp = temp.concat(this.computedPicture((response.productInfo.imageList || []).filter(v => v.position === 1)));
    temp.push({
      fieldType: 'SellOutText',
      isActived: false,
      baseSort: 2,
      isPre: false,
      desc: { sellOutText: response.productInfo.sellOutText || '' },
    });
    temp = temp.concat(this.computedPicture((response.productInfo.imageList || []).filter(v => v.position === 2)));
    temp.push({ fieldType: 'Blank', isActived: false, baseSort: 3, desc: { bHeight: 24 } });
    temp = temp.concat(this.computedPicture((response.productInfo.imageList || []).filter(v => v.position === 3)));
    temp.push({ fieldType: 'ChooseSku', isActived: false, baseSort: 4 });
    temp = temp.concat(this.computedPicture((response.productInfo.imageList || []).filter(v => v.position === 4)));
    temp.push({ fieldType: 'Blank', isActived: false, baseSort: 5, desc: { bHeight: 24 } });
    temp = temp.concat(this.computedPicture((response.productInfo.imageList || []).filter(v => v.position === 5)));
    temp.push({ fieldType: 'ProductInfo', isActived: false, baseSort: 6 });
    temp = temp.concat(this.computedPicture((response.productInfo.imageList || []).filter(v => v.position === 6)));
    temp.push({ fieldType: 'ButtonBar', isActived: false });
    this.data = temp;
  }

  computedPicture(val: ItemArray) {
    if (val && val.length === 1) {
      return val[0].images.map((v) => {
        return {
          fieldType: 'ProductPicture',
          isActived: false,
          position: val[0].position,
          desc: {
            imageUrl: v.imageUrl,
          },
        };
      });
    } else {
      return [];
    }
  }

  onSave() {
    if (this.validate() === -1) {
      const arr = numberToArray(6);
      const imageList = arr
        .map((v, i) => {
          const result = this.data.filter(e => e.fieldType === 'ProductPicture' && e.position === i + 1);
          return {
            position: i + 1,
            images: result.map((r, inx) => {
              return {
                sort: inx + 1,
                imageUrl: r.desc.imageUrl,
              };
            }),
          };
        })
        .filter(v => v && v.images[0] && v.images[0].imageUrl);
      const postParams = {
        sgId: this.baseInfo.sgId,
        sgwpId: this.baseInfo.sgwpId,
        siteId: +this.$route.params.siteId,
        showType: +this.$route.params.siteId ? 5 : 8,
        fieldType: 'ProductInfo',
        productInfo: {
          sellOutText: this.data.find(v => v.fieldType === 'SellOutText').desc.sellOutText,
          imageList,
        },
        ygswpId: this.ygswpId,
      };
      IPSService[+this.$route.params.siteId ? 'siteProductSaveConfig' : 'productInfoConfigSave']({
        postParams,
      }).then((response) => {
        this.data = this.data.map((v) => {
          v.isActived = false;
          return v;
        });
        this.$message.success('保存成功');
      });
    } else {
      this.data = this.data.map((v, i) => {
        v.isActived = this.validate() === i;
        return v;
      });
      this.$nextTick(() => {
        this.$el.querySelector('.is-actived').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      setTimeout(() => {
        if ((this.$refs.config as any).$refs[this.data[this.validate()].fieldType].$refs.form) {
          (this.$refs.config as any).$refs[this.data[this.validate()].fieldType].$refs.form.validate(noop);
        }
      });
    }
  }

  validate(): number {
    const sellIndex = this.data.findIndex(v => v.fieldType === 'SellOutText' && (!v.desc.sellOutText || !v.desc.sellOutText.trim()));
    const pictureIndex = this.data.findIndex(v => v.fieldType === 'ProductPicture' && (!v.desc.imageUrl || !v.desc.imageUrl.trim()));
    return Math.max(sellIndex, pictureIndex);
  }

  render(h) {
    return (
      <section class="nav-Menu shop">
        <div class="nav-container" style="height: calc(100% - 51px)">
          <div class="left-phone overflow-auto-y bg-white" style="width: 25vw;min-width: 475px">
            <ShopDisplay
              v-model={this.data}
              themeCode={Number(this.themeCode)}
              fromPage={4}
              defaultBg={'#f2f2f2'}
              disabledLabel={['Blank', 'ChooseSku', 'ProductInfo', 'ButtonBar']}
              disabledActived={['Blank', 'ChooseSku', 'ProductInfo', 'ButtonBar']}></ShopDisplay>
          </div>
          <ShopDisplayEdit v-model={this.data[this.activedIndex]} themeCode={Number(this.themeCode)} ref="config" />
        </div>
        <div class="bottom-save">
          <el-button type="primary" class="save-btn" onClick={this.onSave}>
            保存
          </el-button>
        </div>
      </section>
    );
  }
}
